import { render, staticRenderFns } from "./AssetsOnLocation.vue?vue&type=template&id=69540b2a&scoped=true"
import script from "./AssetsOnLocation.vue?vue&type=script&lang=js"
export * from "./AssetsOnLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69540b2a",
  null
  
)

export default component.exports